import { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useWebSocket } from './useWebSocket';
import { rtcBufferActions } from '../redux/actions';


let messagesListeners = {};

const useConnector = () => {

    const [tableId, setTableId] = useState();
    
    const email = useSelector(state => state.authState.email ?? '');
    const user = useSelector(state => state.authState.name ?? '');
    const color = useSelector(state => state.authState.color ?? '');
    const outputBuffer = useSelector(state => state.rtcBufferState.outputBuffer);
    const inputBuffer = useSelector(state => state.rtcBufferState.inputBuffer);
    
    const ws = useWebSocket();
    const dispatch = useDispatch();

    const lastTableId = useRef();


    useEffect(() => {
        let blur = () => window.focusOff = true;
        let focus = () => window.focusOff = false;
        let fn = (message) => {
            try {
                let data = JSON.parse(message);
                if (!data) return;
                
                dispatch(rtcBufferActions.pushInputBuffer(data.data));
            } catch(e) {
                console.error(Object.assign(e,{component:'Connector', id: 'pushInputBuffer'}));
            }
        };

        ws.connect({
            user: {tableId, user, color, email},
            onReceiveData: (data) => fn(data),
            onReceiveUserEnter: (user) => messagesListeners["userEnter"] && messagesListeners["userEnter"]({type:"userEnter", data:user}),
            onReceiveUserLeave: (user) => messagesListeners["userLeave"] && messagesListeners["userLeave"]({type:"userLeave", data:user}),
            onReceiveUsers: (users) => users.forEach(u => messagesListeners["userEnter"] && messagesListeners["userEnter"]({type:"userEnter", data:u}))
        });

        window.addEventListener('blur', blur);
        window.addEventListener('focus', focus);

        return () => {
            window.removeEventListener('blur', blur);
            window.removeEventListener('focus', focus);
        }
    },[])

    useEffect(() => {
        if (tableId && tableId !== lastTableId.current) {
            ws.update({tableId, user, color, email});
            lastTableId.current = tableId;
        }
    }, [tableId, user, color, email]);

    useEffect(() => {
        if (!inputBuffer || inputBuffer.length < 1) {
            return;
        }

        try {
            for (let i in messagesListeners) {
                if (i === inputBuffer[0].type) {
                    messagesListeners[i](inputBuffer[0]);
                }
            }
        } catch (e) {
            console.error(Object.assign(e,{component:'Connector', id: 'InputBufferReading'}));
        }

        dispatch(rtcBufferActions.popInputBuffer());
    }, [dispatch, inputBuffer]);

    useEffect(() => {
        if (!outputBuffer || outputBuffer.length < 1) {
            return;
        }

        try {
            let success = ws.send(JSON.stringify({
                data: outputBuffer[0]
            }), outputBuffer[0].to || null);

            if (success) {
                dispatch(rtcBufferActions.popOutputBuffer());
            }
        } catch (e) {
            console.error(Object.assign(e,{component:'Connector', id: 'OutputBufferReading'}));
        }
    }, [outputBuffer, dispatch]);


    return {
        ws,
        setTableId,
        on: (type, fn) => messagesListeners[type] = fn,
        clean: () => messagesListeners = {},
    };
};

export default useConnector;